function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.03 44.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.41,1.62A5.42,5.42,0,0,0,37.28.15L7.92,6.33A9.16,9.16,0,0,0,2.69,21.89L5.84,25a1.87,1.87,0,0,1,.54,1.3v5.81a5.35,5.35,0,0,0,.55,2.36h0l0,0a5.48,5.48,0,0,0,2.5,2.49l0,0v0a5.35,5.35,0,0,0,2.36.55h5.81a1.88,1.88,0,0,1,1.3.54l3.15,3.15A9.09,9.09,0,0,0,28.59,44a9.25,9.25,0,0,0,2.95-.48,9.06,9.06,0,0,0,6.13-7.32l6.2-29.42A5.46,5.46,0,0,0,42.41,1.62Zm-34,20.83L5.28,19.3A5.39,5.39,0,0,1,4,13.66,5.47,5.47,0,0,1,8.54,9.94L37.61,3.83,10,31.4V26.34A5.45,5.45,0,0,0,8.44,22.45ZM34.07,35.61a5.51,5.51,0,0,1-9.34,3.14l-3.15-3.16A5.5,5.5,0,0,0,17.69,34H12.63L40.2,6.42Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.2ef91ef3.svg";
export { ForwardRef as ReactComponent };